var React = require('react');

function IconInfo (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6 0.951172C2.688 0.951172 0 3.63917 0 6.95117C0 10.2632 2.688 12.9512 6 12.9512C9.312 12.9512 12 10.2632 12 6.95117C12 3.63917 9.312 0.951172 6 0.951172ZM6.6 9.95117H5.4V6.35117H6.6V9.95117ZM6.6 5.15117H5.4V3.95117H6.6V5.15117Z"}));
}

IconInfo.defaultProps = {"viewBox":"0 0 12 13"};

module.exports = IconInfo;

IconInfo.default = IconInfo;
